import store from "@/store";
import web from "@/urls/web";
import roles from "./roles";

const {Admin, Owner, Counterman,Agent} = roles();

export default function permission() {
    const init = () => {
        let routes = null;
        if (store.getters.userType === 'Admin') {
            routes = web.Admin;
        } else if (store.getters.userType === 'Owner') {
            routes = web.Owner;
        } else if (store.getters.userType === 'Counterman') {
            routes = web.Counterman;
        } else if (store.getters.userType === 'Agent') {
            routes = web.Agent;
        }
        return routes;
    };

    const getRoute = (role) => {
        if (init()) {
            for (const url of Object.values(init())) {
                if (url.permission && url.permission === role) {
                    return url.name;
                }
            }
        }
        return web.Default.ERROR_URL.name;
    };

    const hasPermission = (role) => {
        if (store.getters.userRoles) {
            for (const typeValues of Object.values(store.getters.userRoles)) {
                if (typeValues === role) {
                    return true;
                }
            }
        }
        return false;
    };

    const permissionGranted = (name) => {
        if (init()) {
            for (const url of Object.values(init())) {
                if (name.includes(url.name) && url.permission && hasPermission(url.permission)) {
                    return true;
                }
            }
        }
        return false;
    };

    const permittedRoute = () => {
        let supportedTypes = null;
        if (store.getters.userType === 'Admin') {
            supportedTypes = [Admin.dashboard, Admin.reports, Admin.adminRead, Admin.companyDeployRead];
        } else if (store.getters.userType === 'Owner') {
            supportedTypes = [Owner.ownerDashboard, Owner.ownerReports, Owner.ownerRead, Owner.ownerCompanySetupRead];
        } else if (store.getters.userType === 'Counterman') {
            supportedTypes = [Counterman.countermanTicketBooking, Counterman.countermanReports, Counterman.countermanTrips, Counterman.countermanShips];
        } else if (store.getters.userType === 'Agent') {
            supportedTypes = [Agent.agentTicketBooking, Agent.agentReports, Agent.agentTrips, Agent.agentShips];
        }
        if (supportedTypes) {
            for (let i = 0; i < supportedTypes.length; i++) {
                if (hasPermission(supportedTypes[i])) {
                    return getRoute(supportedTypes[i]);
                }
            }
        }
        return web.Default.ERROR_URL.name;
    };

    return {
        hasPermission, permissionGranted, permittedRoute
    };
}